import { IconComponent } from '@farol-ds/react'

import AmexIcon from './icons/Amex'
import DinersclubIcon from './icons/Dinersclub'
import DiscoverIcon from './icons/Discover'
import MaestroIcon from './icons/Maestro'
import MastercardIcon from './icons/Mastercard'
import PaypalIcon from './icons/Paypal'
import VisaIcon from './icons/Visa'
import type { PaymentIconMethod } from './payment-icon'

export const PaymentIconMethods = [
  'amex',
  'dinersclub',
  'discover',
  'maestro',
  'mastercard',
  'paypal',
  'visa',
] as const

export const paymentIconLabelMapping: Record<PaymentIconMethod, string> = {
  amex: 'American Express',
  dinersclub: 'Diners Club',
  discover: 'Discover',
  maestro: 'Maestro',
  mastercard: 'Mastercard',
  paypal: 'PayPay',
  visa: 'Visa',
}

export const paymentIconMapping: Record<PaymentIconMethod, IconComponent> = {
  amex: AmexIcon,
  dinersclub: DinersclubIcon,
  discover: DiscoverIcon,
  maestro: MaestroIcon,
  mastercard: MastercardIcon,
  paypal: PaypalIcon,
  visa: VisaIcon,
}
